import React, {useEffect, useState} from "react";
import Dialog from '@material-ui/core/Dialog';
import t from '../../../../helpers/t';
import {useSelector, errorsActions, appLogsActions, resourceDefectsActions} from "inbooma-api";
import {Biscuit} from "../../../../../utils";
import { moment } from "../../../../../../vendor";
import Loader from "../../../../components/Loader";
import showNotification from "../../../../helpers/showNotification";
import DatePicker from "react-datepicker";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-GB";

const ResourceDefectsDialog = (props) => {
    const { resDefect,add, handleCloseDialog, dispatch, resource, setResource, index, getUsernameById } = props;

    const _editResourceDefect = useSelector(state => state.resource_defects_data.patchResourceDefect);
    const _addResourceDefect = useSelector(state => state.resource_defects_data.postResourceDefect);

    const [resourceDefect, setResourceDefect] = useState(resDefect !== null?resDefect:{
        resource_id: resource.id,
        description: '',
        created: moment().format("YYYY-MM-DD HH:mm:00")
    });
    const [editResourceDefectPending, setEditResourceDefectPending] = useState(false);
    const [addResourceDefectPending, setAddResourceDefectPending] = useState(false);

    useEffect(() => {
        if(_addResourceDefect.success === '' || !addResourceDefectPending){
            return;
        }
        if(_addResourceDefect.success === true){
            showNotification('success',_addResourceDefect?.data?.id,'added','defectResource');
            let clone = {};
            Object.assign(clone,resource);
            clone.resource_defects.push(_addResourceDefect?.data);
            setResource(clone);
            setAddResourceDefectPending(false);
        }
        if(_addResourceDefect.success !== true && editResourceDefectPending){
            let message = _addResourceDefect.data.message;
            showNotification('warning', null, message, 'defectResource');
            setAddResourceDefectPending(false);
        }
        handleCloseDialog();
    }, [_addResourceDefect]);

    useEffect(() => {
        if(_editResourceDefect.success === '' || !editResourceDefectPending){
            return;
        }
        if(_editResourceDefect.success === true){
            showNotification('success',_editResourceDefect?.data?.id,'modified','defectResource');
            let clone = {};
            Object.assign(clone,resource);
            clone.resource_defects[index] = _editResourceDefect?.data;
            setResource(clone);
            setEditResourceDefectPending(false);
        }
        if(_editResourceDefect.success !== true && editResourceDefectPending){
            let message = _editResourceDefect.data.message;
            showNotification('warning', resourceDefect.id, message, 'defectResource');
            setEditResourceDefectPending(false);
        }
        handleCloseDialog();
    }, [_editResourceDefect]);

    const submit = () => {
        if(add){
            dispatch(resourceDefectsActions.addResourceDefect(
                {
                    token: Biscuit.get('token'),
                    data: resourceDefect
                }
            ));
            setAddResourceDefectPending(true);
        } else {
            dispatch(resourceDefectsActions.patchResourceDefect(
                {
                    token: Biscuit.get('token'),
                    resource_defect_id: resourceDefect.id,
                    data: resourceDefect
                }
            ));
            setEditResourceDefectPending(true);
        }
    }

    const onChangeCreated = (datetime, type) => {
        const clone = {}
        Object.assign(clone,resourceDefect);
        let date,time;
        switch (type){
            case "date":
                date = moment(datetime).format('YYYY-MM-DD');
                time = moment(clone.created).format('HH:mm:00');
                clone.created = moment(date+' '+time).format('YYYY-MM-DD HH:mm:00');
                break;
            case "time":
                date = moment(clone.created).format('YYYY-MM-DD');
                time = datetime.target.value;
                clone.created = moment(date+' '+time).format('YYYY-MM-DD HH:mm:00');
                break;
        }
        setResourceDefect(clone);
    }

    const onChangeDescription = (description) => {
        const clone = {}
        Object.assign(clone,resourceDefect);
        clone.description = description.target.value;
        setResourceDefect(clone);
    }

    return (
        <>
            <Dialog
                    onClose={handleCloseDialog}
                    aria-labelledby="changelogs-dialog-title"
                    open={true}
                    name="resourceDefectsDialog"
                    id="resourceDefectsDialog"
                    maxWidth={"ld"}
                >
                <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" data-close-on-click="true" aria-hidden="false">
                    <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
                        <h1 className="inb-page-title">{(!add)?t('edit_${a}',{a:t('resourceDefect',null,'capital')}):t('add_${a}',{a:t('defects',null,'capital')})}</h1>
                        <div className="off-canvas__actions column">
                            <button type="submit" className={"button medium beautify beautify-" + Biscuit.get('user.client_id')+ " button-submit round"} title="Speichern" onClick={submit}>
                                {!addResourceDefectPending && !editResourceDefectPending &&
                                    <>
                                        <i className="fi fi-check"></i>
                                        <span>{t('save')}</span>
                                    </>
                                }
                                {(addResourceDefectPending || editResourceDefectPending ) &&
                                    <span><img className="rollingLoader" src="assets/img/rolling_loader.svg" />{t('save')}</span>
                                }
                            </button>
                            <a
                                href='#'>
                                <button onClick={handleCloseDialog} type="button" id="inb-resourcesform-abort-button" className="button hollow secondary right button-abort round" title="Fenster schließen">
                                    <i className="fi fi-x"> </i>
                                </button>
                            </a>
                        </div>
                    </header>
                    { typeof resourceDefect.id !== 'undefined' && resourceDefect.id != null &&
                        <p className="off-canvas__subtitle off-canvas__header-region">
                            {typeof resourceDefect.created !== 'undefined' &&
                                t('created_at') + " " + moment(resourceDefect.created).format('DD.MM.YYYY HH:mm:ss') + " " +
                                t('edited_by') + " " + getUsernameById(resourceDefect.created_by) + " | " +
                                t('last_modified_at') + " " + moment(resourceDefect.modified).format('DD.MM.YYYY HH:mm:ss') + " " +
                                t('edited_by') + " " + getUsernameById(resourceDefect.modified_by)
                            }
                        </p>
                    }

                    <form className="off-content row">


                            <div className="small-6 column">
                                <label className="inb-form__controlLabel">{t('date')}</label>
                                <div className="input-group inb-price-input-group">
                                <div className="float-left" style={{width: "100%"}}>
                                    <div className="small-6 column" style={{padding: 0,float: "left"}}>
                                        <DatePicker
                                            key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                                            className="input-group-field"
                                            dateFormat='dd. MMMM y'
                                            selected={new Date(resourceDefect.created)}
                                            onChange={date => onChangeCreated(date,'date')}
                                            onKeyDown={e => {
                                                if (e.keyCode === 8) e.preventDefault();
                                            }}
                                            placeholderText=""
                                            locale={Biscuit.get('user.lang').indexOf('de') >= 0 ? de : (Biscuit.get('user.lang').indexOf('fr') >= 0 ? fr : en)}
                                        />
                                    </div>
                                    <div className="small-6 column" style={{padding: 0,float: "left"}}>
                                    <input
                                        className="input-group-field"
                                        type="time"
                                        name="created_time"
                                        value={moment(resourceDefect.created).format('HH:mm') }
                                        onChange={(e)=>{onChangeCreated(e,"time")}}
                                    />
                                    </div>
                                </div>
                                </div>
                            </div>
                        <div className="inb-form-group column medium-6 small-6 description">
                            <label className="inb-form__controlLabel">{t('description')}</label>
                            <div className="inb-form__controllClass">
                                <input
                                    className="input-group-field"
                                    type="text"
                                    name="description"
                                    value={resourceDefect.description}
                                    onChange={(e)=>{onChangeDescription(e)}}
                                />

                            </div>
                        </div>
                    </form>
                </div>
            </Dialog>
        </>
    );
}

export default ResourceDefectsDialog;